import React from 'react';
import { Formik, Form } from 'formik';
import { RegisterSchema } from '../../../schemas';
import { useContentfulContext } from '../../../contexts/ContentfulContext';
import { FormikInput } from '../Formik';
import Button from '../Button';

const RegisterForm = ({ submitHandler }) => {
    const { content } = useContentfulContext();

    return (
        <Formik
            initialValues={{
                name: '',
                company: '',
                email: '',
                password: ''
            }}
            validationSchema={() => RegisterSchema(content.REGISTRATION_CONTENT)}
            onSubmit={(values) => {
                submitHandler(values);
            }}
        >
            {() => (
                <Form className="space-y-4 md:space-y-6" action="#" id="registration-form">
                    <FormikInput
                        type="text"
                        id="name"
                        name="name"
                        label={content.REGISTRATION_CONTENT.formLabels.name}
                        placeholder="John Doe"
                    />
                    <FormikInput
                        type="text"
                        id="company"
                        name="company"
                        label={content.REGISTRATION_CONTENT.formLabels.company}
                        placeholder="Acme Corp"
                    />
                    <FormikInput
                        type="email"
                        id="email"
                        name="email"
                        label={content.REGISTRATION_CONTENT.formLabels.email}
                        placeholder="john@example.com"
                    />
                    <FormikInput
                        type="password"
                        id="password"
                        name="password"
                        label={content.REGISTRATION_CONTENT.formLabels.password}
                        placeholder="••••••••"
                    />
                    <div>
                        <Button type="submit" variant="primary" size="lg" className="w-full">
                            {content.REGISTRATION_CONTENT.instruction_text.submit_cta_text}
                        </Button>
                    </div>
                    <div className="flex items-start">
                        <div className="text-sm text-center w-full">
                            <span className="font-light text-gray-500">{content.REGISTRATION_CONTENT.instruction_text.privacy_policy_text}</span>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default RegisterForm;
